import { render, staticRenderFns } from "./SidebarLinkGroup.vue?vue&type=template&id=0c02e8bc"
import script from "./SidebarLinkGroup.vue?vue&type=script&lang=js"
export * from "./SidebarLinkGroup.vue?vue&type=script&lang=js"
import style0 from "./SidebarLinkGroup.vue?vue&type=style&index=0&id=0c02e8bc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports